import Aos from "aos";
import React, { useEffect, useState } from "react";
import email from "../../assets/images/email.webp";
import locationIcon from "../../assets/images/locationIcon.webp";
import logo from "../../assets/images/1.png";
import { Title } from "../../components";
import { Col, Container, Row } from "../../components/GridSystem";
import { ContactList } from "../../contexts/Lists";
import { content } from "../../contexts/useLang";
import { db } from "../../firebase";
import { collection, addDoc } from "firebase/firestore";
import { Link } from "react-router-dom";
import Flag1 from "../../assets/images/Flag (1).png";
import Flag2 from "../../assets/images/Flag (2).png";
import Flag3 from "../../assets/images/Flag (3).png";
import Flag4 from "../../assets/images/Flag (4).png";
import {
  FaEnvelope,
  FaSalesforce,
  FaTools,
  FaFileContract,
  FaExclamationTriangle,
} from "react-icons/fa";

const ContactUs = ({ phoneNumber }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    product: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // إضافة المستند إلى المجموعة "messages"
      await addDoc(collection(db, "messages"), formData);
      alert("تم إرسال النموذج بنجاح!");
      setFormData({ name: "", phone: "", email: "", product: "" });
    } catch (error) {
      console.error("حدث خطأ عند الإرسال: ", error);
    }
  };
  useEffect(() => {
    Aos.init();
  }, []);
  const flags = [Flag3, Flag4, Flag1, Flag2];
  return (
    <div className="mt-14">
      <Container>
        <div>
          <Row>
            {["UAE", "Oman", "Egypt", "Jordan"].map((country, index) => (
              <Col lg={3} md={6} className="h-full !p-1" key={index}>
                <div
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                  data-aos-duration="750"
                  className="h-full bg-gradient-to-br from-black/5 via-black/20 to-black/10 rounded-2xl p-4 backdrop-blur-sm border border-white/10 hover:border-cyan-500/30 transition-all duration-500 group hover:shadow-2xl hover:shadow-cyan-500/10"
                >
                  {/* علم الدولة */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-black/10 flex items-center justify-center group-hover:bg-cyan-500/20 transition-all duration-300">
                      <img
                        src={flags[index]}
                        alt=""
                        className={index === 1 ? "w-8 h-8" : "object-cover"}
                      />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold group-hover:text-cyan-300 transition-colors duration-300">
                        {content[country]}
                      </h3>
                    </div>
                  </div>

                  {/* العنوان */}
                  <div className="mb-4">
                    <div className="flex items-start gap-2 min-h-[80px]">
                      <svg
                        className="w-5 h-5 text-cyan-400 mt-0.5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                      <div>
                        <div className="text-sm text-gray-400">
                          {content[country + "_"]}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* الهاتف */}
                  <div className="mb-4">
                    <div className="flex items-center gap-2">
                      <svg
                        className="w-5 h-5 text-cyan-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>
                      <div>
                        {content[country + "_phone"]?.split("/").map((e, i) => (
                          <div key={i}>
                            <a
                              href={`tel:${e?.replace(/\s/g, "")}`}
                              className="text-sm hover:text-cyan-300 transition-colors duration-300 hover:underline"
                            >
                              {e}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* البريد الإلكتروني - تصميم محسّن */}
                  <div className="mb-4">
                    <div className="space-y-2">
                      {content[country + "_emails"]
                        ?.split("&")
                        .map((email, i) => {
                          const emailText = email.trim();
                          let IconComponent;
                          let label;
                          let colorClass;
                          let bgGradient;

                          if (emailText.toLowerCase().includes("sales")) {
                            IconComponent = FaSalesforce;
                            label = "Sales";
                            colorClass = "text-blue-400";
                            bgGradient = "from-blue-900/20 to-blue-500/10";
                          } else if (
                            emailText.toLowerCase().includes("technicalsupport")
                          ) {
                            IconComponent = FaTools;
                            label = "Tech Support";
                            colorClass = "text-green-400";
                            bgGradient = "from-green-900/20 to-green-500/10";
                          } else if (
                            emailText.toLowerCase().includes("maintenance")
                          ) {
                            IconComponent = FaFileContract;
                            label = "Maintenance";
                            colorClass = "text-yellow-400";
                            bgGradient = "from-yellow-900/20 to-yellow-500/10";
                          } else if (
                            emailText.toLowerCase().includes("complains")
                          ) {
                            IconComponent = FaExclamationTriangle;
                            label = "Complaints";
                            colorClass = "text-red-400";
                            bgGradient = "from-red-900/20 to-red-500/10";
                          } else {
                            IconComponent = FaEnvelope;
                            label = "General";
                            colorClass = "text-purple-400";
                            bgGradient = "from-purple-900/20 to-purple-500/10";
                          }

                          return (
                            <a
                              key={i}
                              href={`mailto:${emailText}`}
                              className={`flex items-center p-2 rounded-lg bg-gradient-to-r ${bgGradient} hover:bg-gradient-to-r hover:from-cyan-900/30 hover:to-cyan-500/20 border border-white/5 hover:border-cyan-500/20 transition-all duration-300 group/email`}
                            >
                              <div
                                className={`p-2 rounded-lg bg-black/20 ${colorClass} mr-3`}
                              >
                                <IconComponent className="text-lg" />
                              </div>
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center justify-between">
                                  <span className="font-medium text-sm text-white truncate">
                                    {label}
                                  </span>
                                  <span className="text-xs px-2 py-1 rounded bg-black/30 text-gray-300 ml-2">
                                    {i + 1}
                                  </span>
                                </div>
                                <div className="text-xs text-gray-400 truncate mt-1">
                                  {emailText}
                                </div>
                              </div>
                              <svg
                                className="w-4 h-4 text-gray-500 group-hover/email:text-cyan-300 ml-2 transition-colors duration-300"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                />
                              </svg>
                            </a>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
        <Title title="contact_us" />
        <div className="border border-Dark rounded-3xl px-8 py-6 mx-auto bg-Light shadow-lg">
          {/* الهيدر - للجوال فقط */}
          <div className="flex items-center gap-3 md:hidden mb-6">
            <div>
              <img src={logo} alt="Logo" className="w-20" />
            </div>
            <div className="font-semibold text-lg">
              {content.prime_pixels_technology}
            </div>
          </div>

          <Row className="items-center">
            <Col md={6} className="space-y-6 max-md:order-2 pt-6 max-md:pt-8">
              {/* قسم روابط التواصل السريع */}
              <div className="bg-gradient-to-r from-gray-50 to-white p-5 rounded-2xl border border-gray-100 shadow-sm">
                <div className="text-center mb-4">
                  <h3 className="text-xl font-bold text-gray-800">
                    {content.quick_links}
                  </h3>
                  <p className="text-gray-500 text-sm mt-1">
                    {content.connect_with_us}
                  </p>
                </div>
                <div className="flex justify-center items-center flex-wrap gap-4">
                  {ContactList.map((e, i) => (
                    <div
                      key={i}
                      className="image-container rounded-full transform transition-all duration-300 hover:scale-110 hover:shadow-lg"
                      data-aos="zoom-out-up"
                      data-aos-delay={i * 50}
                      data-aos-duration="750"
                    >
                      <a
                        href={e.link ? e.link : "https://wa.me/" + phoneNumber}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block p-2 bg-white rounded-full border border-gray-200 hover:border-cyan-400 transition-colors"
                      >
                        <img
                          src={e.image}
                          alt="contact_us"
                          className="w-12 h-12 md:w-14 md:h-14"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>

              {/* قسم الإيميلات الإضافية */}
              <div className="bg-gradient-to-r from-cyan-50 to-blue-50 p-5 rounded-2xl border border-cyan-100 shadow-sm">
                <div className="flex items-center gap-2 mb-4">
                  <svg
                    className="w-5 h-5 text-cyan-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                  <h3 className="text-lg font-bold text-gray-800">
                    Executive Contacts
                  </h3>
                </div>
                <div className="space-y-3">
                  <a
                    href="mailto:CEO@brilliant-grp.com"
                    className="flex items-center p-3 bg-white rounded-xl border border-gray-200 hover:border-cyan-400 hover:shadow-md transition-all duration-300 group"
                  >
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center mr-3">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5.121 17.804A7 7 0 0114.828 17H19a2 2 0 002-2v-5a2 2 0 00-2-2h-1.586a1 1 0 01-.707-.293l-1.121-1.121A2 2 0 0015.172 7H8.828a2 2 0 00-1.414.586L6.293 8.707A1 1 0 015.586 9H4a2 2 0 00-2 2v6a2 2 0 002 2h.172a7 7 0 01.949-1.196z"
                        />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <div className="font-medium text-gray-800">
                        CEO Office
                      </div>
                      <div className="text-sm text-gray-600 truncate">
                        CEO@brilliant-grp.com
                      </div>
                    </div>
                    <svg
                      className="w-4 h-4 text-gray-400 group-hover:text-cyan-500 transition-colors"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>

                  <a
                    href="mailto:chairman.office@brilliant-egy.com"
                    className="flex items-center p-3 bg-white rounded-xl border border-gray-200 hover:border-cyan-400 hover:shadow-md transition-all duration-300 group"
                  >
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-pink-400 flex items-center justify-center mr-3">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                        />
                      </svg>
                    </div>
                    <div className="flex-1">
                      <div className="font-medium text-gray-800">
                        Chairman Office
                      </div>
                      <div className="text-sm text-gray-600 truncate">
                        chairman.office@brilliant-egy.com
                      </div>
                    </div>
                    <svg
                      className="w-4 h-4 text-gray-400 group-hover:text-cyan-500 transition-colors"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </Col>

            <Col md={6} className="max-md:order-1">
              {/* اللوجو للشاشات الكبيرة */}
              <div className="max-md:hidden mb-6 text-center">
                <img src={logo} alt="Logo" className="w-28 mx-auto" />
                <div className="mt-2 text-lg font-semibold text-gray-800">
                  {content.prime_pixels_technology}
                </div>
              </div>

              {/* نموذج الاتصال */}
              <div className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-2xl border border-gray-100 shadow-sm">
                <h3 className="text-xl font-bold text-gray-800 mb-6 text-center">
                  {content.contact_form}
                </h3>

                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {content.name}:
                    </label>
                    <input
                      onChange={handleChange}
                      value={formData.name}
                      name="name"
                      type="text"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:border-cyan-400 focus:ring-2 focus:ring-cyan-100 transition-all duration-300 outline-none"
                      placeholder={content.enter_your_name}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {content.phone_number}:
                    </label>
                    <input
                      onChange={handleChange}
                      value={formData.phone}
                      name="phone"
                      type="text"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:border-cyan-400 focus:ring-2 focus:ring-cyan-100 transition-all duration-300 outline-none"
                      placeholder={content.enter_phone_number}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {content.email}:
                    </label>
                    <input
                      onChange={handleChange}
                      value={formData.email}
                      name="email"
                      type="email"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:border-cyan-400 focus:ring-2 focus:ring-cyan-100 transition-all duration-300 outline-none"
                      placeholder={content.enter_your_email}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {content.product_you_are_interested}:
                    </label>
                    <select
                      onChange={handleChange}
                      value={formData.product}
                      name="product"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:border-cyan-400 focus:ring-2 focus:ring-cyan-100 transition-all duration-300 outline-none appearance-none bg-white"
                    >
                      <option value="" hidden>
                        {content.select_product}
                      </option>
                      {[1, 2, 3, 4, 5, 6, 7].map((e) => (
                        <option key={e} value={content["products_" + e]}>
                          {content["products_" + e]}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="pt-4">
                    <button
                      onClick={handleSubmit}
                      className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 transform hover:scale-[1.02] shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                    >
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                        />
                      </svg>
                      <span>{content.inquiry_send}</span>
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* الفوتر */}
          <div className="mt-10 pt-6 border-t border-gray-200">
            <div className="text-center text-gray-600 text-sm mb-4">
              <p className="font-medium mb-1">
                All rights reserved to Brilliant Future Trading Company
              </p>
              <p className="text-gray-500">Dubai - UAE</p>
            </div>

            <div className="text-center">
              <Link
                to="/privacy-policy"
                className="text-cyan-600 hover:text-cyan-700 font-medium transition-colors duration-300 inline-flex items-center gap-1"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  />
                </svg>
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ContactUs;
